import { BannersApi, FindAllByPlatformIdBannerTypeEnum } from "@app/bf-api";
import { moduleMapperThrowMessage } from "@app/api/wp-page-fetcher/utils/module-mapper-error-handling";
import Logger from "@app/util/logger";

export type BannersGetApiProps = {
  platformId: number;
  bannerType?: FindAllByPlatformIdBannerTypeEnum;
  filters?: string;
};

export const bannersGetApi = async ({
  platformId,
  bannerType = FindAllByPlatformIdBannerTypeEnum.OVERVIEW,
  filters
}: BannersGetApiProps) => {
  try {
    const api = new BannersApi();
    const resultFromApi = await api.findAllByPlatformId({
      platformId,
      bannerType,
      returnDefault: true,
      filters: filters || undefined
    });

    if (!resultFromApi) return moduleMapperThrowMessage("Cannot get banners");

    return resultFromApi;
  } catch (e) {
    Logger.logError(e, "Error in: bannersGetApi");

    return undefined;
  }
};
